// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.challenge-overview-grid .grid-data {
  height: 82vh !important;
}
.challenge-overview-grid {
  padding: 10px 10px;
}
.challenge-options .date-picker-container {
  display: flex;
  gap: 12px;
}
.challenge-overview-grid .StageTwoButtonComponentMainSection {
  text-align: end;
  margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/views/components/base/grid/ChallengeOverViewGrid.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,eAAe;EACf,mBAAmB;AACrB","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.challenge-overview-grid .grid-data {\n  height: 82vh !important;\n}\n.challenge-overview-grid {\n  padding: 10px 10px;\n}\n.challenge-options .date-picker-container {\n  display: flex;\n  gap: 12px;\n}\n.challenge-overview-grid .StageTwoButtonComponentMainSection {\n  text-align: end;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
